/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_Feature_LogInputs */

const en_price_page_app_feature_log = /** @type {(inputs: Price_Page_App_Feature_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited workouts, new bests and strength score`)
};

const pl_price_page_app_feature_log = /** @type {(inputs: Price_Page_App_Feature_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi bez limitu, rekordy i wynik siły`)
};

/**
* | output |
* | --- |
* | "Unlimited workouts, new bests and strength score" |
*
* @param {Price_Page_App_Feature_LogInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_feature_log = /** @type {((inputs?: Price_Page_App_Feature_LogInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_Feature_LogInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_feature_log(inputs)
	return en_price_page_app_feature_log(inputs)
});